import { ATSPrincipalAppCandidateModalTabsTestIds } from 'data-testids/ATS';
import { Box } from '@mui/material';
import { CandidateTabContentProps } from 'features/Principal/types/modalTypes';

import { CandidatePreferences } from './CandidatePreferences';
import { CandidateOverview } from './CandidateOverview';

export const BasicInfoTab: React.FC<CandidateTabContentProps> = ({ row, onEmailClick }) => {
  return (
    <Box data-testid={ATSPrincipalAppCandidateModalTabsTestIds.BASIC_INFO_TAB}>
      <CandidateOverview row={row} onEmailClick={onEmailClick} />
      <CandidatePreferences preferences={row.candidate?.preferences} />
    </Box>
  );
};
